export default {
  isochrones: {
    'isochrones': 'Izokron vonalak',
    'isochronesReady': 'Az izokron vonalak elkészültek',
    'calculatingIsochrones': 'Izokron vonalak kiszámítása…',
    'itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions': 'A megadott beállításokkal nem lehetett kiszámítani az izokron vonalakat. Tegyen egy próbát kisebb izokron vonalakkal.',
    'couldResolveTheSelectedPlaceAsASuitableCenter': 'A kiválasztott pontot nem lehetett megfelelő középpontként beállítani.',
    'apiError': {
      '2003': 'Egy elkerülendő sokszög területe legfeljebb 20.000 négyzetkilométer lehet.',
      '3001': 'Legalább egy paraméter értéke vagy formátuma hibás.',
      '3004': 'A kiválasztott profil, intervallum és idő vagy távolság kombinációja meghaladja a legnagyobb támogatott értéket. Kérjük, korrigálja az értékeket.',
      '3099': 'A kiválasztott pont(ok)hoz és profilhoz nem lehet izokron térképet készíteni.'
    },
    'genericErrorMsg': 'Nem lehetett kiszámítani az izokron vonalakat.',
    timeoutError: 'A kérés túl sokáig tartott, és megszakították. Próbálkozzon kisebb tartományokkal vagy intervallumokkal.'
  }
}
